module.exports = __webpack_public_path__ + "img/15-s.39ac499c.png";